import classNames from "classnames";
import {IconType} from "react-icons";
import {FiAlertTriangle, FiCheck, FiTool} from "react-icons/fi";

import {PulseIcon} from "./PulseIcon.tsx";

import styles from "./InspireGlobalStatus.module.scss";

export enum GlobalStatusType {
  OPERATIONAL = "OPERATIONAL",
  ISSUES = "ISSUES",
  MAINTENANCE = "MAINTENANCE",
}

interface InspireGlobalStatusProps {
  status: GlobalStatusType;
  // Resolved by the header through formatGlobalStatusDuration, which also sizes the clearance the
  // card needs: both have to agree on whether this row exists or the reserved height is wrong.
  durationText: string | null;
}

const STATUS_CONFIG: Record<GlobalStatusType, {className: string; Icon: IconType; text: string}> = {
  [GlobalStatusType.OPERATIONAL]: {className: styles.operational, Icon: FiCheck, text: "All Systems Operational"},
  [GlobalStatusType.ISSUES]: {
    className: styles.issues,
    Icon: FiAlertTriangle,
    text: "Experiencing a major service disruption",
  },
  [GlobalStatusType.MAINTENANCE]: {className: styles.maintenance, Icon: FiTool, text: "Maintenance"},
};

export const InspireGlobalStatus = ({status, durationText}: InspireGlobalStatusProps) => {
  const {className, Icon, text} = STATUS_CONFIG[status];

  return (
    <div className={classNames(styles.container, className)} data-testid="global-status-banner">
      <div className={styles.statusGroup}>
        <Icon className={styles.icon} />
        <span className={styles.statusText}>{text}</span>
      </div>
      {durationText && (
        <div className={styles.duration}>
          <PulseIcon status="up" className={styles.pulseIconReset} /> For:{" "}
          <span className={styles.durationValue}>{durationText}</span>
        </div>
      )}
    </div>
  );
};
